import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { useLocalStorage } from 'react-use';
import { authAPI } from '../services/api';
import { LoginCredentials } from '../services/interfaces';

export interface User {
  id: string;
  email: string;
  name?: string;
}

export const useAuth = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [user, setUser] = useLocalStorage<User | null>('user', null);

  const profileQuery = useQuery('profile', () => authAPI.getProfile(), {
    enabled: !!user,
    retry: false,
    onError: () => { setUser(null); },
  });

  const loginMutation = useMutation(
    (credentials: LoginCredentials) => authAPI.login(credentials),
    {
      onSuccess: (data) => {
        if (data.success && data.user) {
          setUser(data.user);
          queryClient.setQueryData('profile', data.user);
          navigate('/admin/campaigns');
        }
      },
      onError: (error: any) => { console.error('Login error:', error); },
    }
  );

  const logoutMutation = useMutation(() => authAPI.logout(), {
    onSuccess: () => {
      setUser(null);
      queryClient.clear();
      navigate('/admin/login');
    },
  });

  return {
    user: profileQuery.data || user,
    isLoading: profileQuery.isLoading,
    isAuthenticated: !!user,
    login: loginMutation.mutateAsync,
    logout: logoutMutation.mutateAsync,
    isLoggingIn: loginMutation.isLoading,
    isLoggingOut: logoutMutation.isLoading,
    error: loginMutation.error,
  };
};
